import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { TextInputComponent } from "../../../../common/components";
import './filter-options-text.scss';

const EmailFilter: any = (
  props: any
) => {
  const { email, handleEmailChange, isEmailEnabled, emailError } = props
  useEffect(() => {
    if (!isEmailEnabled) {
      handleEmailChange({ target: { value: "", name: "email" } } as any, "email");
    }
  }, [isEmailEnabled]);
  return (
    <div className="filter-options-text-wrapper">
      <Formik
        initialValues={{
          email: email,
        }}
        onSubmit={(values) => {
          console.log("Form Submitted with values:", values);
        }}
      >
        <Form className="filter-options">
          <TextInputComponent
            type="text"
            fieldName="email"
            placeholder="Enter Email"
            optional={false}
            disabled={false}
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              handleEmailChange(e, "email")
            }
          />
          {emailError && <div className="error-text">{emailError}</div>}
        </Form>
      </Formik>
    </div>

  );
};
export default EmailFilter;